import React from "react";

interface WeeklyCostChartPanelProps {
  title: string;
  icon?: React.ReactNode;
  meta?: string;
  children: React.ReactNode;
  bodyClassName?: string;
  headerAction?: React.ReactNode;
}

const WeeklyCostChartPanel = ({
  title,
  icon,
  meta,
  children,
  bodyClassName,
  headerAction,
}: WeeklyCostChartPanelProps) => (
  <div className="min-h-[240px] md:min-h-0 h-full overflow-hidden rounded-[8px] border border-[var(--panel-body-border)] bg-[var(--card-bg)] flex flex-col">
    <div className="weekly-cost-panel-header shrink-0 flex items-center justify-between gap-2 bg-[var(--panel-header-bg)] px-3 md:px-4 py-2">
      <div className="flex items-center gap-2 min-w-0">
        {icon && (
          <div className="weekly-cost-panel-icon text-[var(--panel-header-text)] flex-shrink-0">
            {icon}
          </div>
        )}
        <span className="weekly-cost-panel-title text-[14px] font-semibold text-[var(--panel-header-text)] truncate">
          {title}
        </span>
      </div>
      <div className="flex items-center gap-2">
        {headerAction}
        {meta && (
          <span className="text-[10px] text-[var(--text-tertiary)] flex-shrink-0">
            {meta}
          </span>
        )}
      </div>
    </div>
    <div className={`flex-1 min-h-0 overflow-hidden p-0.5 ${bodyClassName ?? ""}`}>
      {children}
    </div>
  </div>
);

export default WeeklyCostChartPanel;
